// extracted by mini-css-extract-plugin
export default {"checkboxLabel":"checkbox_checkboxLabel__xxLYC","checkbox":"checkbox_checkbox__a8PlP"};